import {matchPath,  useLocation} from "react-router-dom";
import {Button, ButtonProps} from "@mui/material";
import {  styled} from "@mui/material/styles";
import React from "react";
import {CustomLink} from "../CustomLink/CustomLink";
import {PathPattern} from "react-router";
import {translateRoute} from "../../routes/AppRoutes";
import {useTranslation} from "react-i18next";

interface HeaderLinkProps extends ButtonProps {
    to: string;
    activeOn?: (PathPattern | string)[];
}
const StyledButton = styled(Button)(({theme}) =>
    ({
        paddingTop:3,
        paddingBottom:3,
        borderRadius:0,
        color:theme.palette.primary.contrastText,
        height:'100%',
        '&.active':{
            paddingBottom:0,
            borderBottom:`2px solid ${theme.palette.primary.main}`
        }
    })) as typeof Button;

export const HeaderLink = (props:HeaderLinkProps) =>{
    let location = useLocation();
const {t,i18n} = useTranslation();
    let from = location.pathname || "/";
    return (
        <StyledButton disableRipple component={CustomLink} className={props.activeOn?.find(x => matchPath(x, from)) || matchPath(translateRoute(props.to,i18n.language,t), from) ? "active" : ""}
                variant="text" to={props.to} sx={props.sx}>{props.children}</StyledButton>
    )
}